import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import api from '../services/api';
import { getMediaUrl } from '../services/api';
import './AnnouncementPopup.css';

const AnnouncementPopup = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    loadAnnouncements();
  }, []);

  const loadAnnouncements = async () => {
    try {
      const response = await api.get('/announcements/', {
        params: { display_type: 'popup' }
      });
      
      const fetchedAnnouncements = response.data;
      if (fetchedAnnouncements && fetchedAnnouncements.length > 0) {
        const sorted = fetchedAnnouncements.sort((a, b) => a.display_order - b.display_order);
        setAnnouncements(sorted);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Error loading announcements:', error);
    }
  };

  const handleNext = () => {
    if (currentIndex < announcements.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setShowPopup(false);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  if (!announcements.length || !showPopup) {
    return null;
  }

  const currentAnnouncement = announcements[currentIndex];
  const hasMultiple = announcements.length > 1;

  return (
    <Modal 
      show={showPopup} 
      onHide={handleClose}
      centered
      className="announcement-modal"
      size="lg"
    >
      <Modal.Body className="announcement-popup" style={{
        backgroundColor: currentAnnouncement.background_color || '#fff3cd'
      }}>
        <Button 
          variant="close" 
          onClick={handleClose}
          aria-label="Close"
          className="announcement-close-btn"
        />
        
        <div className="announcement-content">
          {currentAnnouncement.icon && (
            <i className={`${currentAnnouncement.icon} announcement-icon`}></i>
          )}
          
          <h4 className="announcement-title">{currentAnnouncement.title}</h4>
          
          <div 
            className="announcement-description"
            dangerouslySetInnerHTML={{ __html: currentAnnouncement.description }}
          />
          
          {currentAnnouncement.link_url && (
            <div className="announcement-action">
              <a 
                href={currentAnnouncement.link_url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                {currentAnnouncement.link_text || 'Learn More'}
                <i className="fas fa-arrow-right ms-2"></i>
              </a>
            </div>
          )}
        </div>

        {hasMultiple && (
          <div className="announcement-footer">
            <div className="announcement-dots">
              {announcements.map((_, index) => (
                <span 
                  key={index}
                  className={`dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
            
            <div className="announcement-navigation">
              <Button 
                variant="outline-dark"
                size="sm"
                onClick={handlePrevious}
                disabled={currentIndex === 0}
                className="nav-btn"
              >
                <i className="fas fa-chevron-left"></i> Previous
              </Button>
              
              <span className="announcement-counter">
                {currentIndex + 1} of {announcements.length}
              </span>
              
              <Button 
                variant="primary"
                size="sm"
                onClick={handleNext}
                className="nav-btn"
              >
                {currentIndex === announcements.length - 1 ? (
                  <>Close <i className="fas fa-check"></i></>
                ) : (
                  <>Next <i className="fas fa-chevron-right"></i></>
                )}
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AnnouncementPopup;
